module.exports = "<p>\n  testing works!\n</p>\n"